







import { Component, Vue } from 'vue-property-decorator'

// Views
import ContactUsModal from '@/views/all/modals/ContactUsModal.vue'
import DownloadAppModal from '@/views/all/modals/DownloadAppModal.vue'

@Component({
  components: {
    ContactUsModal,
    DownloadAppModal
  }
})
export default class TopBarLinks extends Vue {
  get helpUrl(): string {
    return process.env.VUE_APP_SUPPORT_URL
  }

  openContactModal() {
    this.$modal.open({
      parent: this,
      component: ContactUsModal
    })
  }

  openAppDownloadModal() {
    this.$modal.open({
      parent: this,
      component: DownloadAppModal
    })
  }
}
